import Minze, { MinzeElement, Reactive, EventListeners, Watch, Attrs } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Routing } from '../../modules/routing'
import { Locale } from '../../modules/locale'
import { AdditionalTypes } from '../../modules/additionalTypes'
import { Font } from '../../constants'
import { Callback } from '../../modules/callback'

export interface LvcCultureCategoryModalContent {
  selectedCategories: string[]
  onChipClick: string
  count: number
  dataCulture: string
  dataCultureDescription: string
  dataId: string
}

export class LvcCultureCategoryModalContent extends MinzeElement {
  attrs: Attrs = ['data-id', 'data-culture', 'data-culture-description']
  categories: any[] = []
  reactive: Reactive = [['selectedCategories', []], 'count']

  private renderCategories() {
    return this.categories
      .map(category => {
        return `
        <lvc-chip enable-hover-animation="true"
          theme="dark"
          width="fit-content"
          value=${category.code}
          class="category-chip"
          on-click="${this.onChipClick}"
          selected="${this.selectedCategories?.includes(category.code)}"
        >
          ${category.label}
        </lvc-chip>
      `
      })
      .join('')
  }

  private renderSelector() {
    let isDeselctAll = this.selectedCategories?.length >= this.categories?.length

    return `
      <button id="btn-toggle-all">
        ${Locale.getKey(isDeselctAll ? 'general.deselectAll' : 'general.selectAll')}
      </button>
    `
  }

  html = () => `
    <div class="form">
      <lvc-box mt="8px">
        <lvc-text font-preset="small">
          ${this.dataCultureDescription || ''}
        </lvc-text>
      </lvc-box>
      ${this.renderSelector()}
      <lvc-box mt="24px" display="flex" columnGap="8px" rowGap="8px" flexWrap="wrap">
        ${this.renderCategories()}
      </lvc-box>
      <lvc-box mt="24px" display="flex" width="100%" right="16px" columnGap="16px" class="button-wrapper">
        <lvc-box width="100%">
          <lvc-button enable-hover-box-shadow="true" width="100%" id="btn-save">
            ${Locale.getKey('general.save')}
          </lvc-button>
        <lvc-box>
      </lvc-box>
    </div>
  `

  css = () => `
    :host {

    }
    #btn-toggle-all {
      display: flex;
      height: 40px;
      padding: 0px 16px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 60px;
      border: 1px solid var(--brand-minuit, #1E007D);
      cursor: pointer;
      color: var(--brand-minuit, #1E007D);
      text-align: right;
      font-variant-numeric: lining-nums tabular-nums;
      font-feature-settings: 'clig' off, 'liga' off;

      /* D/boutons/principal */
      font-family: ${Font.family};
      font-size: 14px;
      font-style: normal;
      font-weight: ${Font.weight.medium};
      line-height: 120%; /* 16.8px */
      background: transparent;
    }


    @media screen and (max-width: 991px) {
      .button-wrapper {
        position: fixed;
        bottom: 73px;
        left: 0;
        right: 0;
        padding: 18px 16px;
        width: 100%;
        height: fit-content;
        max-width: calc(540px + 16*2px);
        margin: auto;
      }
    }
  `
  async onReady(): Promise<void> {
    this.count = 0
    this.onChipClick = Callback.attach(this.onSelectCategory.bind(this))

    const mainModule = MainModule.getInstance()

    this.categories = await AdditionalTypes.getInstance().getSubCategoriesBySlug(this.dataId)

    const userData = mainModule.getAuth().getUserData()
    if (userData?.profile?.culturalProfile && this.dataId) {
      const culture = userData.profile?.culturalProfile?.[this.dataId]

      this.selectedCategories = culture
    }

    if (!this.selectedCategories) {
      this.selectedCategories = []
    }

    this.rerender()
  }

  onDestroy(): void {
    Callback.detach(this.onChipClick)
  }

  onSelectCategory = (data: any) => {
    const categoryValue = data.value

    if (this.selectedCategories.includes(categoryValue)) {
      this.selectedCategories = this.selectedCategories.filter(
        selectedCategory => selectedCategory !== categoryValue
      )
    } else {
      this.selectedCategories = this.selectedCategories.concat(categoryValue)
    }

    this.count = this.count + 1
  }

  onSelectAllToggle() {
    if (this.selectedCategories?.length >= this.categories?.length) {
      this.selectedCategories = []
    } else {
      this.selectedCategories = this.categories.map(category => category.code)
    }
    this.count = this.selectedCategories.length
    this.rerender()
  }

  goBack() {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileCulture)
  }

  saveSubCategories = async () => {
    const mainModule = MainModule.getInstance()
    const data: any = {}
    data[this.dataId as string] = this.selectedCategories
    await mainModule.getAuth().saveProfile(`profile-culture`, data)
    mainModule.showToastAlert(Locale.getKey('profileCultureMain.changeSavedMsg'))

    // add a delay to let the user see the success message
    setTimeout(() => {
      this.goBack()
    }, 1000)
  }

  eventListeners: EventListeners = [
    ['#btn-toggle-all', 'click', this.onSelectAllToggle.bind(this)],
    ['#btn-back', 'click', this.goBack.bind(this)],
    ['#btn-save', 'click', this.saveSubCategories.bind(this)],
  ]
}
